/** Planning Phase 3 P3-6b (plan D-294)：OSC 外部编号面板、搜索、导入与资料包的字符串。 */
export default {
  osc: {
    ids: {
      otherScheme: '其他编号类型…',
      customScheme: '编号类型代码',
      issuerFromSettings: '默认为 设置 → 规划 中的议会代码 {{pbt}}。',
      issuerMissing: '设置 → 规划 中没有议会代码：请填写签发此编号的单位。',
      patternWarning: '这看起来不像常见的 {{scheme}}。请与 OSC 核对；仍可关联。',
      linkedWithWarning: '已关联，但它看起来不像此类常见编号。请与 OSC 核对。',
      multi: '可对应多个申请',
      unlink: '取消关联',
      unlinkLabel: '取消关联 {{value}}',
      unlinkTitle: '取消关联此编号',
      unlinkBody: '编号 {{value}} 将从此申请移除。案件历史会保留该关联及您的原因。',
      reason: '原因',
      reasonHint: '保存在案件历史中；申请人看不到。',
      reasonRequired: '请填写原因。',
      confirm: '确认取消关联',
      cancel: '保留',
    },
    search: {
      label: '外部编号',
      placeholder: 'OSC 编号，与记录完全一致',
      submit: '查找',
      clear: '清除编号',
      active: '关联到 {{value}} 的申请',
      landmark: '按外部编号查找',
    },
    intake: {
      title: '来自 OSC 的文件',
      intro: '从 OSC 3.0 Plus 导入申请的 PDF，可一次一个或多个。',
      choose: '选择 PDF',
      type: '{{name}} 的文件类型',
      upload: '导入',
      progress: '正在导入第 {{done}} 个，共 {{total}} 个…',
      done: '已导入。',
      failed: '未导入。请检查文件后重试。',
      remove: '移除 {{name}}',
      retry: '重试',
      retryLabel: '重试：{{name}}',
    },
    bundle: {
      title: 'OSC 资料包',
      intro: '需要录入 OSC 3.0 Plus 的内容：录入表、核对清单和 PDF。此处不会向 OSC 发送任何内容。',
      prepare: '准备资料包',
      refresh: '重新准备',
      download: '下载资料包（zip）',
      progress: '正在获取第 {{done}} 个 PDF，共 {{total}} 个…',
      failed: '无法生成资料包。请重试。',
      header: '申请',
      caseRef: '编号',
      stage: '当前步骤',
      checklist: '已同步到 OSC',
      checklistHint: '录入 OSC 后勾选该项。只有本议会的官员能看到这些勾选。',
      markLabel: '已同步：{{item}}',
      entrySheet: '录入表',
      documents: '供 OSC 使用的 PDF',
      noDocuments: '没有需要复制到 OSC 的 PDF。',
      excluded: '未放入资料包',
      marking: '正在保存…',
      withdrawn: '征询已撤回',
      withdrawnWithAgency: '已撤回向{{agency}}发出的征询',
      referralKinds: { internal: '议会部门', external: '外部机构' },
      referralStatuses: { open: '待处理', answered: '已回复', withdrawn: '已撤回' },
      yes: '是',
      no: '否',
      kinds: {
        transition: '步骤',
        referral_requested: '已发出征询',
        referral_answered: '征询已回复',
        document: '文件',
      },
      kindsWithAgency: {
        referral_requested: '已向{{agency}}发出征询',
        referral_answered: '{{agency}}已回复征询',
      },
      reasons: { too_large: '超过 10 MB：OSC 不接受', not_pdf: '不是 PDF', inbound: '来自 OSC' },
      outcomes: { requirements: '有要求', no_requirements: '无要求', deemed: '未回复（视为无异议）' },
      fields: {
        agency: '机构',
        kind: '内部或外部',
        requestedOn: '征询日期',
        dueOn: '截止日期',
        outcome: '回复',
        answeredOn: '回复日期',
        late: '逾期',
        conditions: '要求数量',
        pCodes: '合规阶段',
        docType: '文件类型',
        file: '资料包中的文件',
        size: '大小（字节）',
        revision: '修订版',
        status: '请求状态',
      },
      csv: { item: '项目', screen: 'OSC 画面', field: '字段', value: '值', date: '日期', mirrored: '已同步到 OSC' },
    },
  },
} as const
